var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "X"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M51.4142 48.5861C51.6 48.7719 51.7474 48.9925 51.8479 49.2353C51.9485 49.4781 52.0003 49.7383 52.0003 50.0011C52.0003 50.2639 51.9485 50.5241 51.8479 50.7669C51.7474 51.0097 51.6 51.2303 51.4142 51.4161C51.2283 51.6019 51.0077 51.7493 50.765 51.8499C50.5222 51.9505 50.262 52.0022 49.9992 52.0022C49.7364 52.0022 49.4762 51.9505 49.2334 51.8499C48.9906 51.7493 48.77 51.6019 48.5842 51.4161L31.9992 34.8286L15.4142 51.4161C15.0389 51.7914 14.5299 52.0022 13.9992 52.0022C13.4684 52.0022 12.9594 51.7914 12.5842 51.4161C12.2089 51.0408 11.998 50.5318 11.998 50.0011C11.998 49.4704 12.2089 48.9614 12.5842 48.5861L29.1717 32.0011L12.5842 15.4161C12.2089 15.0408 11.998 14.5318 11.998 14.0011C11.998 13.4704 12.2089 12.9614 12.5842 12.5861C12.9594 12.2108 13.4684 12 13.9992 12C14.5299 12 15.0389 12.2108 15.4142 12.5861L31.9992 29.1736L48.5842 12.5861C48.9594 12.2108 49.4684 12 49.9992 12C50.5299 12 51.0389 12.2108 51.4142 12.5861C51.7894 12.9614 52.0003 13.4704 52.0003 14.0011C52.0003 14.5318 51.7894 15.0408 51.4142 15.4161L34.8267 32.0011L51.4142 48.5861Z",
    fill: "#000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.775ca8a29e686f782066b67a6972193d.svg";
export { ForwardRef as ReactComponent };